// @flow
import JQueryView, { on } from '../../common/JQueryView';

declare var $: any;

export default class IndexView extends JQueryView {
  constructor() {
    super('.index');
  }

  @on({
    event: 'click',
    selector: '.prior-consent-template-close',
  })
  onClosePriorConsentTemplate() {
    $('.prior-consent-template')
      .removeClass('d-flex')
      .addClass('d-none');
  }
}
